import { canv } from "@/canv/global";
import { ArrowWidget } from "@/elements/arrow";
import { eventEmitter } from "@/eventEmitter";
import { Group } from "@/group";
import { t } from "@/i18n";
import { toolBase } from "@/tools/toolBase";
import { selectionManager, transformManager } from "../cursorTool";

export class ArrowTool extends toolBase {
    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M23.2807 7.21979L20.2807 4.21979C20.14 4.07906 19.9491 4 19.7501 4C19.5511 4 19.3602 4.07906 19.2195 4.21979C19.0787 4.36052 18.9997 4.55139 18.9997 4.75042C18.9997 4.94944 19.0787 5.14031 19.2195 5.28104L20.9398 7.00042H19.7501C15.1254 7.00042 14.0267 9.63667 13.0582 11.9617C12.1788 14.072 11.472 15.767 8.41947 15.9779C8.22792 15.0686 7.70554 14.2627 6.95361 13.7166C6.20168 13.1706 5.27377 12.9231 4.34977 13.0223C3.42577 13.1215 2.57152 13.5602 1.95262 14.2535C1.33372 14.9467 0.994265 15.845 1.00007 16.7743C1.00588 17.7036 1.35653 18.5976 1.98405 19.2831C2.61157 19.9685 3.47124 20.3965 4.39641 20.4842C5.32158 20.5718 6.24632 20.3128 6.99137 19.7573C7.73641 19.2019 8.24868 18.3896 8.42885 17.4779C12.4845 17.2295 13.5232 14.7451 14.442 12.5382C15.3823 10.2817 16.1248 8.50042 19.7501 8.50042H20.9398L19.2195 10.2198C19.0787 10.3605 18.9997 10.5514 18.9997 10.7504C18.9997 10.9494 19.0787 11.1403 19.2195 11.281C19.3602 11.4218 19.5511 11.5008 19.7501 11.5008C19.9491 11.5008 20.14 11.4218 20.2807 11.281L23.2807 8.28104C23.3505 8.21139 23.4058 8.12867 23.4435 8.03762C23.4813 7.94657 23.5007 7.84898 23.5007 7.75042C23.5007 7.65186 23.4813 7.55426 23.4435 7.46321C23.4058 7.37216 23.3505 7.28945 23.2807 7.21979ZM4.7501 19.0004C4.30509 19.0004 3.87007 18.8685 3.50006 18.6212C3.13005 18.374 2.84167 18.0226 2.67137 17.6115C2.50107 17.2003 2.45651 16.7479 2.54333 16.3115C2.63015 15.875 2.84444 15.4741 3.15911 15.1594C3.47378 14.8448 3.87469 14.6305 4.31114 14.5436C4.7476 14.4568 5.2 14.5014 5.61114 14.6717C6.02227 14.842 6.37367 15.1304 6.6209 15.5004C6.86814 15.8704 7.0001 16.3054 7.0001 16.7504C7.0001 17.3472 6.76305 17.9194 6.34109 18.3414C5.91913 18.7634 5.34683 19.0004 4.7501 19.0004Z"/>
            </svg>
        `;
    }

    getToolTipName() {
        return t("tools.connectors");
    }

    getToolHotKey() {
        return "L";
    }

    select() {
        super.select();
        eventEmitter.dispatch("arrowToolMenu.visibility", { isVisible: true });

        const pt = canv.actionManager.getActionPoint();

        this.creationX = pt.x;
        this.creationY = pt.y;
    }

    unselect() {
        super.unselect();

        eventEmitter.dispatch("arrowToolMenu.visibility", { isVisible: false });
    }

    getWidgetWrapper() {
        const newArrow = new ArrowWidget(0, 0, 0, 0);

        newArrow.color = this.color;
        newArrow.lineWidth = this.lineWidth;
        newArrow.lineType = this.lineType;
        newArrow.updateDims();
        newArrow.dashType = this.dashType;
        newArrow.firstEndType = this.firstEndType;
        newArrow.lastEndType = this.lastEndType;

        const newGroup = new Group(true);

        newArrow.setParent(newGroup);

        return newGroup;
    }

    setColor(color: string) {
        this.color = color;
    }

    setLineWidth(lineWidth: number) {
        this.lineWidth = lineWidth;
    }

    setLineType(lineType: string) {
        this.lineType = lineType;
        eventEmitter.dispatch("arrowToolMenu.type", { lineType: lineType });
    }

    setDashType(dashType: string) {
        this.dashType = dashType;
    }

    setFirstEndType(firstEndType: string) {
        this.firstEndType = firstEndType;
    }

    setLastEndType(lastEndType: string) {
        this.lastEndType = lastEndType;
    }

    TryAction(type: string) {
        canv.redraw();

        if (type === "mousedown") {
            this.createdPt = canv.actionManager.getActionPoint();
        } else if (type === "mousemove") {
            if (this.createdPt !== null) {
                const createdArrowWrapper = this.getWidgetWrapper() as Group;

                const pt = this.createdPt;
                const child = createdArrowWrapper.onlyChild() as unknown as ArrowWidget;
                const firstPoint = child?.getFirstPoint();
                const lastPoint = child?.getLastPoint();

                if (firstPoint) {
                    firstPoint.x = pt.x;
                    firstPoint.y = pt.y;
                }

                if (lastPoint) {
                    lastPoint.x = pt.x;
                    lastPoint.y = pt.y;
                }

                // Добавляем стрелку
                canv.canvasController.addGroup(createdArrowWrapper);
                canv.eventManager.openRecord();
                canv.eventManager.createBuildEvent("create", createdArrowWrapper);

                for (let i = canv.canvasController.items.length - 1; i >= 0; i--) {
                    const res = canv.canvasController.items[i].TryMagnet(child, "firstPoint", true);
                    if (res.status) {
                        child.firstPointPlace = res.place;
                        firstPoint.x = res.x;
                        firstPoint.y = res.y;
                    }
                }

                canv.eventManager.closeRecord();

                child.updateDims();

                const cursorTool = canv.toolBox.TryGetToolByName("cursorTool");

                selectionManager.setSelected([createdArrowWrapper], false);
                createdArrowWrapper.fixWidgets("resize");
                cursorTool.turnMode("resize");
                transformManager.setCatchPointer("lastPoint");

                this.createdPt = null;
            } else {
                const pt = canv.actionManager.getActionPoint();

                this.creationX = pt.x;
                this.creationY = pt.y;

                for (let i = canv.canvasController.items.length - 1; i >= 0; i--) {
                    const res = canv.canvasController.items[i].TryMagnet(null, "firstPoint");

                    if (res.status) {
                        this.creationX = res.x;
                        this.creationY = res.y;
                    }
                }
            }
        } else if (type === "mouseup") {
            this.createdPt = null;
            const createdArrowWrapper = this.getWidgetWrapper();
            const child = createdArrowWrapper.onlyChild() as unknown as ArrowWidget;
            const firstPoint = child.getFirstPoint();

            for (let i = canv.canvasController.items.length - 1; i >= 0; i--) {
                const res = canv.canvasController.items[i].TryMagnet(child, "firstPoint", true);
                if (res.status) {
                    child.firstPointPlace = res.place;
                    firstPoint.x = res.x;
                    firstPoint.y = res.y;
                }
            }

            const cursorTool = canv.toolBox.TryGetToolByName("cursorTool");

            cursorTool.turnMode("");
            canv.toolBox.switchTo(cursorTool);
        }
    }

    draw() {
        const pointerSize = canv.actionManager.getZoomConstant(10);

        canv.ctx.fillStyle = "white";
        canv.ctx.strokeStyle = "#0B99FF";
        canv.ctx.lineWidth = pointerSize / 4;

        canv.ctx.beginPath();
        canv.ctx.arc(this.creationX, this.creationY, pointerSize / 2, 0, 2 * Math.PI);
        canv.ctx.stroke();
        canv.ctx.fill();
        canv.ctx.closePath();
    }

    name = "arrowTool";
    creationX = 0;
    creationY = 0;

    lineWidth = 1;
    color = "black";
    lineType = "curved";
    dashType = "solid";
    firstEndType = "none";
    lastEndType = "filled";

    createdPt: { x: number; y: number } | null = null;
}
